import React, { Component } from "react";
import clsx from "clsx";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  Cell,
} from "recharts";

import {
  selectFormat,
  MAIN_COLORS as _MAIN_COLORS,
  StandardTooltip,
  Error,
  getAllKeys,
} from "./../Utils/Utils.js";

const MAIN_COLORS = [_MAIN_COLORS[0], _MAIN_COLORS[2], _MAIN_COLORS[1]];

class BarChartLegendsStackedSummary extends Component {
  renderBars = (data) => {
    let bars = [];
    let all_bars = [];

    const sortedKeys = this.getSortedKeys(data);

    for (let i = 0; i <= data.length - 1; i++) {
      sortedKeys.forEach((source) => all_bars.push(source));
    }

    const isFixedBarWidth = data.length <= 7;

    [...new Set(all_bars)].forEach((bar, i) => {
      bars.push(
        <Bar
          key={i}
          dataKey={bar}
          stackId="stack"
          barSize={isFixedBarWidth ? 35 : null}
          fill={MAIN_COLORS[i]}
        >
          {data.map(
            (entry, index) =>
              entry && (
                <Cell
                  key={`cell-${bar}-${index}`}
                  fillOpacity={entry[bar] < 0 ? 0.5 : 1}
                />
              )
          )}
        </Bar>
      );
    });

    return bars;
  };

  legendElement = (data) =>
    data.map((entry, i) => (
      <span key={i} className="legend mt-2 mt-md-0">
        <span className="legend__icon" style={{ background: MAIN_COLORS[i] }} />
        <span className="legend__text" style={{ color: MAIN_COLORS[i] }}>
          {entry}
        </span>
      </span>
    ));

  renderLegends = (data) => {
    let legends = [];
    let all_legends = [];

    const sortedKeys = this.getSortedKeys(data);

    for (let i = 0, j = data.length; i <= j - 1; i++) {
      sortedKeys.forEach((source) => all_legends.push(source));
    }

    legends = [...new Set(all_legends)];
    return this.legendElement(legends);
  };

  getSortedKeys(_data) {
    if (!_data) return [];
    if (!_data[0]) return [];
    const data = _data.filter((d) => d);

    const keys = getAllKeys(data, ["date", "name", "fullName"]);
    const len = data.length;

    return keys
      .map((key) => ({
        key: key,
        value: data.reduce((accum, curr) => accum + (curr[key] || 0), 0) / len,
      }))
      .sort((a, b) => b.value - a.value)
      .map((d) => d.key);
  }

  getExportData = () => ({
    data: this.props.data.data,
    opts: {
      type: "chart",
    },
  });

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={120} />;
    }

    return (
      <React.Fragment>
        {this.renderLegends(data.data)}
        <ResponsiveContainer height={120} width="100%">
          <BarChart
            data={data.data}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            stackOffset="sign"
          >
            <Tooltip
              cursor={{ fill: "#eee", opacity: 0.5 }}
              content={
                <StandardTooltip
                  render={({ data }) => {
                    const payload = data(this.props);

                    if (payload !== null) {
                      const tooltip_data = payload[0].payload;
                      const total = payload.reduce(
                        (acc, cur) => acc + (cur.value || 0),
                        0
                      );
                      return (
                        <div className="standard-tooltip">
                          {tooltip_data.name && (
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Month:
                              </span>
                              <span className="standard-tooltip__value-header">
                                {tooltip_data.fullName}
                              </span>
                            </header>
                          )}
                          <main className="standard-tooltip__main">
                            {Object.keys(payload)
                              .sort(
                                (a, b) => payload[b].value - payload[a].value
                              )
                              .map((key, index) => (
                                <div
                                  className="standard-tooltip__item"
                                  key={key}
                                >
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{ background: payload[key].color }}
                                  />
                                  <span
                                    className={clsx(
                                      "standard-tooltip__key",
                                      "text-capitalize"
                                    )}
                                    style={{ color: payload[key].color }}
                                  >
                                    {payload[key].dataKey}{" "}
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat("number", payload[key].value)}
                                  </span>
                                </div>
                              ))}

                            <div className="standard-tooltip__dilimiter1" />

                            <div className="standard-tooltip__item">
                              <span
                                className={clsx(
                                  "standard-tooltip__key",
                                  "text-capitalize",
                                  "total"
                                )}
                              >
                                Total{" "}
                              </span>
                              <span className="standard-tooltip__value">
                                {selectFormat("number", total)}
                              </span>
                            </div>
                          </main>
                        </div>
                      );
                    }
                  }}
                />
              }
            />

            {this.renderBars(data.data)}

            <XAxis
              dataKey="name"
              tickLine={false}
              axisLine={false}
              scale="auto"
            />
          </BarChart>
        </ResponsiveContainer>
      </React.Fragment>
    );
  }
}

export default BarChartLegendsStackedSummary;
